/* tslint:disable */
import { defineMessages } from 'react-intl';

export default defineMessages({
    matchTitle: {
        defaultMessage:
            '{productName, select, unknown {{matchTitle} betting, {tournamentName} {date} in {time}} other {{matchTitle} betting, {tournamentName} {date} in {time} - {productName}}}',
        id: 'match.Match.title',
    },
    noOutrightMessageDefault: {
        defaultMessage: 'No outright found with id',
        id: 'components.NoOutrightWithId',
    },
    todayText: {
        defaultMessage: 'Today',
        id: 'todayText',
    },
    filterText: {
        defaultMessage: 'Filters',
        id: 'global.filterText',
    },
    theaterMode: {
        defaultMessage: 'Theater mode',
        id: 'global.theaterMode',
    },
    tournamentTitle: {
        defaultMessage:
            '{productName, select, unknown {{tournamentName}} other {{tournamentName} Betting - {productName}}}',
        id: 'global.tournamentTitle',
    },
    normalMode: {
        defaultMessage: 'Normal mode',
        id: 'global.normalMode',
    },
    loading: {
        defaultMessage: 'Loading',
        id: 'global.loading',
    },
    timeIsUp: {
        defaultMessage: 'Module loading timed out',
        id: 'global.timeIsUp',
    },
    uploadError: {
        defaultMessage: 'Error has occured while uploading module',
        id: 'global.uploadError',
    },
    moreOdds: {
        defaultMessage: 'More odds',
        id: 'global.moreOdds',
    },
    upcoming: {
        defaultMessage: 'Upcoming games',
        id: 'global.upcoming',
    },
    upcomingShort: {
        defaultMessage: 'Upcoming',
        id: 'global.upcomingShort',
    },
    outrights: {
        defaultMessage: 'Outrights',
        id: 'global.outrights',
    },
    results: {
        defaultMessage: 'Results',
        id: 'global.results',
    },
    deactivated: {
        id: 'global.deactivated',
        defaultMessage: 'Deactivated',
    },
    event: {
        id: 'global.event',
        defaultMessage: 'Event',
    },
    selectPlaceholder: {
        id: 'global.selectPlaceholder.',
        defaultMessage: 'Select',
    },
    selectedDropdownElement: {
        id: 'global.selectedDropdownElement',
        defaultMessage: 'Selected',
    },
    draw: {
        defaultMessage: 'Draw',
        id: 'global.draw',
    },
    stream: {
        defaultMessage: 'Stream',
        id: 'global.stream',
    },
    matchTrackerTitle: {
        defaultMessage: 'Match centre',
        id: 'global.matchTrackerTitle',
    },
    watch: {
        defaultMessage: 'Watch',
        id: 'global.watch',
    },
    marketTotal: {
        defaultMessage: 'Total',
        id: 'marketName.Total',
    },
    marketHandicap: {
        defaultMessage: 'Handicap',
        id: 'marketName.Handicap',
    },
    marketWinner: {
        defaultMessage: 'Winner',
        id: 'marketName.Winner',
    },
    won: {
        defaultMessage: 'WIN',
        id: 'global.odd.Won',
    },
    lost: {
        defaultMessage: 'LOSS',
        id: 'global.odd.Lost',
    },
    score: {
        id: 'global.score',
        defaultMessage: 'Score',
    },
    prizePool: {
        defaultMessage: 'Prize Pool:',
        id: 'global.prizePool',
    },
    defaultTournamentDescription: {
        defaultMessage:
            'Place your bet on {name} tournament with best odds! You can place an ordinary bet on the outcome of an individual match or take a risk and make an express bet on several outcomes to multiply your winnings!',
        id: 'global.tournamentDescription',
    },
    promo: {
        id: 'global.promo',
        defaultMessage: 'Promo',
    },
    live: {
        id: 'global.live',
        defaultMessage: 'Live',
    },
    nextToGo: {
        id: 'global.nextToGo',
        defaultMessage: 'Next To Go',
    },
    myBets: {
        id: 'global.myBets',
        defaultMessage: 'my bets',
    },
    hide: {
        id: 'global.hide',
        defaultMessage: 'hide',
    },
    over: {
        defaultMessage: 'over',
        id: 'global.over',
    },
    under: {
        defaultMessage: 'under',
        id: 'global.under',
    },
    oddsFormat: {
        defaultMessage: 'Odds format',
        id: 'global.oddsFormat',
    },
    oddsStatistic: {
        defaultMessage: 'Odds statistic',
        id: 'global.oddsStatistic',
    },
    byMatch: {
        defaultMessage: 'by match',
        id: 'global.byMatch',
    },
    byMarket: {
        defaultMessage: 'by markets',
        id: 'global.byMarket',
    },
    show: {
        defaultMessage: 'Show',
        id: 'global.show',
    },
    Decimal: {
        defaultMessage: 'Decimal',
        id: 'global.Decimal',
    },
    Fractional: {
        defaultMessage: 'Fractional',
        id: 'global.Fractional',
    },
    HongKong: {
        defaultMessage: 'HongKong',
        id: 'global.HongKong',
    },
    Indo: {
        defaultMessage: 'Indo',
        id: 'global.Indo',
    },
    Malay: {
        defaultMessage: 'Malay',
        id: 'global.Malay',
    },
    US: {
        defaultMessage: 'US',
        id: 'global.US',
    },
    favorites: {
        defaultMessage: 'favorites',
        id: 'global.favorites',
    },
    top: {
        defaultMessage: 'top',
        id: 'global.top',
    },
    popular: {
        defaultMessage: 'popular',
        id: 'global.popular',
    },
    daily: {
        defaultMessage: 'Next 24 hours',
        id: 'global.daily',
    },
    weekly: {
        defaultMessage: 'weekly',
        id: 'global.weekly',
    },
    monthly: {
        defaultMessage: 'monthly',
        id: 'global.monthly',
    },
    all: {
        defaultMessage: 'All',
        id: 'global.all',
    },
    allGames: {
        defaultMessage: 'All Games',
        id: 'global.allGames',
    },
    unpin: {
        defaultMessage: 'unpin',
        id: 'global.unpin',
    },
    ChangeHistory: {
        defaultMessage: 'History Change',
        id: 'global.ToggleHistory',
    },
    more: {
        defaultMessage: 'More',
        id: 'outright.OddTypes.more',
    },
    EXPRESS: {
        defaultMessage: 'EXPRESS',
        id: 'betslip.EXPRESS',
    },
    SINGLE: {
        defaultMessage: 'SINGLE',
        id: 'betslip.SINGLE',
    },
    SYSTEM: {
        defaultMessage: 'SYSTEM',
        id: 'betslip.SYSTEM',
    },
    showSettings: {
        defaultMessage: 'Settings',
        id: 'global.showSettings',
    },
    featured: {
        defaultMessage: 'Featured',
        id: 'global.featured',
    },
    bettingSlip: {
        defaultMessage: 'Betting Slip',
        id: 'betslip.BettingSlip',
    },
    bettingSlipBetTitle: {
        defaultMessage: '{count,plural, one {Outcome}  other {Outcomes}}',
        id: 'betslip.BettingSlip.BetTitle',
    },
    totalOdd: {
        defaultMessage: 'Total Odds',
        id: 'betslip.BetslipFooter.TotalRow.totalOdd',
    },
    on: {
        defaultMessage: 'On',
        id: 'global.On',
    },
    off: {
        defaultMessage: 'Off',
        id: 'global.Off',
    },
    statistics: {
        defaultMessage: 'statistics',
        id: 'global.statistics',
    },
    organizationGrandSlam: {
        defaultMessage: 'Grand Slam tournaments',
        id: 'global.organizationGrandSlam',
    },
    organizationTeams: {
        defaultMessage: 'Teams tournaments',
        id: 'global.organizationTeams',
    },
    organizationATP: {
        defaultMessage: 'ATP',
        id: 'global.organizationATP',
    },
    organizationWTA: {
        defaultMessage: 'WTA',
        id: 'global.organizationWTA',
    },
    organizationATPChallengerSeries: {
        defaultMessage: 'ATP. Challenger Series',
        id: 'global.organizationATPChallengerSeries',
    },
    organizationITFMen: {
        defaultMessage: 'ITF. Men',
        id: 'global.organizationITFMen',
    },
    organizationITFWomen: {
        defaultMessage: 'ITF. Women',
        id: 'global.organizationITFWomen',
    },
    organizationExhibitionMatches: {
        defaultMessage: 'Exhibition matches',
        id: 'global.organizationExhibitionMatches',
    },
    specialBets: {
        defaultMessage: 'specialBets',
        id: 'global.specialBets',
    },
    esport: {
        defaultMessage: 'ESport',
        id: 'global.esport',
    },
    csport: {
        defaultMessage: 'Sport',
        id: 'global.csport',
    },
    team: {
        defaultMessage: 'Team',
        id: 'global.team',
    },
    yes: {
        defaultMessage: 'Yes',
        id: 'global.yes',
    },
    no: {
        defaultMessage: 'No',
        id: 'global.no',
    },
    matchListPageTitle: {
        defaultMessage:
            '{productName, select, unknown {Esports Betting and Odds Online} other {Esports Betting and Odds Online at {productName}}}',
        id: 'global.matchListPageTitle',
    },
    topSpecifier: {
        defaultMessage: 'Top',
        id: 'global.topSpecifier',
    },
    other: {
        defaultMessage: 'Other',
        id: 'global.other',
    },
});
